import { Routes } from '@angular/router';
import { ProfileRoutes } from '@core';
import {
  AllTrophiesComponent,
  ChangePasswordComponent,
  ContactComponent,
  EditProfileComponent,
  ProfileComponent,
  ReferralComponent
} from './components';

export const ProfileRouting: Routes = [
  {
    path: ProfileRoutes.EDIT,
    component: EditProfileComponent
  },
  {
    path: ProfileRoutes.CONTACT,
    component: ContactComponent
  },
  {
    path: ProfileRoutes.REFERRAL,
    component: ReferralComponent
  },

  {
    path: ProfileRoutes.ALL_TROPHIES,
    component: AllTrophiesComponent
  },
  {
    path: ProfileRoutes.CHANGE_PASSWORD,
    component: ChangePasswordComponent
  },
  {
    path: ProfileRoutes.ID,
    component: ProfileComponent
  }
];
